import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Supabase's default browser key. Exporting it gives the app a deterministic
// local fallback when a network sign-out cannot complete.
const supabaseProjectRef = new URL(supabaseUrl).hostname.split(".")[0];
export const SUPABASE_AUTH_STORAGE_KEY = `sb-${supabaseProjectRef}-auth-token`;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true, // 🚩 Esto es lo que permite que no se cierre la sesión
    autoRefreshToken: true, // 🚩 Esto hace la magia por debajo
    detectSessionInUrl: true
  }
});
